import {
    ReportSettingsSpot,
    ReportSettingsSpotExplanation,
    explainReportSettingsSpot,
    toSpotResolutionInput,
} from "@common/helpers/report-settings/explain-report-setting-spot";
import {
    AppliedReportTemplate,
    ReportSettingsTarget,
} from "@common/helpers/report-settings/report-setting-candidates";
import { ReportSettingsStoredRow } from "@common/helpers/report-settings/report-setting-fields";
import {
    ReportSettingsResolution,
    resolveReportSettings,
} from "@common/helpers/report-settings/resolve-report-settings";
import { ReportSettingsConcreteReportKey } from "@common/types/reports/report-settings-report-key";
import { ReportSettingsDraft, applyDrafts } from "./reportSettingsDrafts";

interface DraftViewInput {
    workspaceId?: string;
    rows: ReportSettingsStoredRow[];
    drafts: ReportSettingsDraft[];
    entityTemplate?: AppliedReportTemplate;
    workspaceTemplate?: AppliedReportTemplate;
    firmDefaultTemplate?: { id: string };
}

const templateInputs = ({
    entityTemplate,
    workspaceTemplate,
    firmDefaultTemplate,
}: DraftViewInput) => ({
    entityTemplate,
    workspaceTemplate,
    firmDefaultTemplate,
});

export const getSpotView = ({
    spot,
    ...input
}: DraftViewInput & {
    spot: ReportSettingsSpot;
}): ReportSettingsSpotExplanation =>
    explainReportSettingsSpot({
        ...templateInputs(input),
        workspaceId: input.workspaceId,
        rows: applyDrafts(input),
        spot,
    });

export const getPreviewValues = ({
    target,
    reportKey,
    ...input
}: DraftViewInput & {
    target: ReportSettingsTarget;
    reportKey: ReportSettingsConcreteReportKey;
}): ReportSettingsResolution =>
    resolveReportSettings(
        toSpotResolutionInput(
            {
                ...templateInputs(input),
                workspaceId: input.workspaceId,
                rows: applyDrafts(input),
                spot: { target, reportKey },
            },
            reportKey,
        ),
    );
